module.exports = __webpack_public_path__ + "img/52a177b4d2ef47446c722ae4147f7c94.b5c2e7d8.png";